export { Note } from './Note';
export type { Props } from './Note.types';
